import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=5607ad88&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=5607ad88&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607ad88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DownloadManager: require('/usr/src/app/components/file/DownloadManager.vue').default,ClaudiaFileDownloader: require('/usr/src/app/components/asideComponents/claudiaFileDownloader.vue').default,S2TheHeader: require('/usr/src/app/node_modules/front-components/components/layout/TheHeader.vue').default,UserConfiguration: require('/usr/src/app/components/configuration/UserConfiguration.vue').default})
